import { render, staticRenderFns } from "./configurationSettings.vue?vue&type=template&id=0cd29db1&scoped=true"
import script from "./configurationSettings.vue?vue&type=script&lang=js"
export * from "./configurationSettings.vue?vue&type=script&lang=js"
import style0 from "./configurationSettings.vue?vue&type=style&index=0&id=0cd29db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd29db1",
  null
  
)

export default component.exports